/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {StandardAction} from './standard-action';
import {PortalApp} from '../../auth/portal-app/portal-app';

export class PortalAction extends StandardAction {
  public isOpen: boolean;
  public applications: PortalApp[];

  public constructor(apps: PortalApp[]) {
    super('portal', null, null, 'portal.navigation');
    this.category = 'portal';
    this.align = 'right';
    this.applications = apps.filter(a => a.active);
  }
}
